import { Box, Button, Dialog, Typography } from '@mui/material';
import { IconSpeakerphone } from '@tabler/icons';

import useUserAnnouncements from 'hooks/useUserAnnouncements';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { usePrevious } from 'react-use';
import DialogClose from '../buttons/DialogClose';

const NewAnnouncementsDialog = () => {
  const { userAnnouncements } = useUserAnnouncements();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const announcementCount = useMemo(() => {
    return userAnnouncements?.announcements?.filter((value: any) => value.seen === false)?.length || 0;
  }, [userAnnouncements?.announcements]);

  const preAnnouncementCount = usePrevious(announcementCount);

  useEffect(() => {
    const shouldShowModal = localStorage.getItem('shownAnnouncementAlerts') !== 'true';

    if (shouldShowModal && preAnnouncementCount === undefined && announcementCount) {
      // check if user is logged in before showing the modal
      setIsModalOpen(true);
      localStorage.setItem('shownAnnouncementAlerts', 'true');
    }
  }, [announcementCount, preAnnouncementCount]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Dialog
        open={isModalOpen && Number(announcementCount) > 0}
        onClose={closeModal}
        PaperProps={{
          sx: {
            backgroundColor: 'white',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
            textAlign: 'center',
            alignItems: 'center',
            minWidth: 300,
            p: 0
          }
        }}
      >
        <DialogClose onClose={closeModal} />

        <Box sx={{ pb: 3, p: 3 }}>
          <IconSpeakerphone size={0} color="#444" strokeWidth={1.8} />
          <Typography
            variant="h3"
            sx={{
              fontSize: 16,
              fontWeight: '600',
              lineHeight: '1.334em',
              fontFamily: 'Roboto,sans-serif',
              color: '#616161',
              py: 1
            }}
          >
            {announcementCount > 1 ? (
              <FormattedMessage values={{ announcementCount }} defaultMessage="You have {announcementCount} new notifications!" />
            ) : (
              <FormattedMessage values={{ announcementCount }} defaultMessage="You have {announcementCount} new notification!" />
            )}
          </Typography>

          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={closeModal} style={{ width: '150px' }}>
              <FormattedMessage defaultMessage="Not Now" />
            </Button>
            <Link to="/notifications">
              <Button variant="contained" onClick={closeModal} style={{ marginLeft: '20px', width: '150px' }}>
                <FormattedMessage defaultMessage="Show me" />
              </Button>
            </Link>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default NewAnnouncementsDialog;
